export function roundToDecimals(number: number, decimals = 2) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}

/**
 * Parse a CSS time value (e.g., "200ms", "0.2s") to milliseconds.
 */
export function parseCssDuration(value: string, defaultDuration = 0): number {
  const trimmed = value.trim();

  if (trimmed.endsWith('ms')) {
    return parseFloat(trimmed);
  }

  if (trimmed.endsWith('s')) {
    return parseFloat(trimmed) * 1000;
  }

  return defaultDuration;
}
